import React from 'react';
import ChatBot from './ChatBot';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faRobot } from '@fortawesome/free-solid-svg-icons';

// Styled components for the embedded version
const EmbeddedChatContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  background-color: white;
`;

const ChatHeader = styled.div`
  padding: 12px 16px;
  background-color: #0066ff;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ChatTitle = styled.div`
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  padding: 4px;
  border-radius: 4px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

const ChatContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
`;

const EmbeddedChatBot = ({ knowledgeBaseCode, conversationId, context, executionResults, onClose }) => {
  // Handle close event properly to ensure floating button reappears
  const handleClose = () => {
    if (onClose) {
      onClose(); // This will set isChatVisible to false in the parent component
    }
  };
  
  // We pass the chatbot component but override its styling to fit the embedded container
  return (
    <EmbeddedChatContainer>
      <ChatHeader>
        <ChatTitle>
          <FontAwesomeIcon icon={faRobot} /> Meta Pilot
        </ChatTitle>
        <CloseButton onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </ChatHeader>
      <ChatContent>
        <ChatBot 
          isOpen={true}
          onClose={handleClose}
          knowledgeBaseCode={knowledgeBaseCode}
          conversationId={`AH-${conversationId}`}
          context={context}
          embedded={true} 
          executionResults={executionResults}
        />
      </ChatContent>
    </EmbeddedChatContainer>
  );
};

export default EmbeddedChatBot;
